let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("780j6")).then(() => parcelRequire('d0OMT'));